const initialStore = {
    // ui related
    isAsyncRequest: 0, // number
    isError404: false,
    // user
    token: ''
}

export default initialStore;